import { render, staticRenderFns } from "./Reg_selectPhoto.vue?vue&type=template&id=5306dd74&scoped=true"
import script from "./Reg_selectPhoto.vue?vue&type=script&lang=js"
export * from "./Reg_selectPhoto.vue?vue&type=script&lang=js"
import style0 from "./Reg_selectPhoto.vue?vue&type=style&index=0&id=5306dd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5306dd74",
  null
  
)

export default component.exports